<template>
  <TemplateReplyNormal
    :post="post"
    :prevPost="prevPost"
    :nextPost="nextPost"

    :isAuthor="isAuthor"
    :fileUpLoadAction="fileUpLoad.action"
    :fileUpLoadHeaders="fileUpLoad.headers"

    @handleClickPrevPost="handleClickPrevPost"
    @handleClickNextPost="handleClickNextPost"
    @handleClickRegister="handleClickRegister"
    @handleChangeFile="handleChangeFile"
    @handleSuccessFileUpload="handleSuccessFileUpload"
    @handleDeleteFile="handleDeleteFile"
  ></TemplateReplyNormal>
</template>

<script>
import config from '/public/config'
import TemplateReplyNormal from '@/views/board/template/reply/TemplateReplyNormal'
import VueCookie from 'vue-cookie'

export default {
  name: 'BoardReply',
  components: {
    TemplateReplyNormal
  },

  computed: {
    isAuthor () {
      if (this.post.author && this.activeUserInfo) {
        const postAuthorId = this.post.author.id
        const userId = this.activeUserInfo.id
        return postAuthorId === userId
      }

      return false
    }
  },

  data () {
    return {
      boardSlug: '',
      boardId: 0,
      postId: 0,
      post: {},
      prevPost: { title:'이전글', postId:0 },
      nextPost: { title:'다음글', postId:0 },

      // 이전글 id, 다음글 id를 구하기 위해서 사용됨
      tableCurrentPage:0, // 현재 페이지 번호
      tablePerPage:0, // 페이지당 노출되는 게시물 개수
      tableSearchKeyword:'', // 검색어
      tablePrevPage:0,
      tableNextPage:0,

      form: {
        title:''
      },

      // 파일 업로드 서버 정보
      fileUpLoad:{
        headers: '',
        action:`${config.BASE_API_URL}/api/v1/file`,
        files: [] // 등록하고자 하는 파일 목록
      }
    }
  },

  created () {
    this.boardSlug = this.$route.params.boardslug
    this.boardId = 1
    this.postId = this.$route.params.postId

    // notice id 가 없을때 처리
    if (!this.postId) {
      this.$router.back()
      return
    }


    // file upload 시 사용되는 xmlrequest header
    this.fileUpLoad.headers = {
      Authorization: `Bearer ${VueCookie.get('token')}`
    }

    this.loadPostDetail()

  },

  methods: {
    async registerPost (_title, _content) {

      const boardId = this.boardId
      const parentId = this.postId
      const title = _title
      const content = _content
      let uploads = ''
      if (this.fileUpLoad.files.length > 0) {
        const upload = []
        for (const temp of this.fileUpLoad.files) {
          upload.push(temp.uploadedFileId)
        }
        uploads = JSON.stringify(upload)
      }

      await this.$store.dispatch('board/CREATE_POST', {boardId, parentId, title, content, uploads})

      this.$router.back()
    },

    async loadPostDetail () {
      // cookie 정보를 가져온다.
      this.loadCookieBoard()

      // 내용불러오기
      const boardId = this.boardId
      const postId = this.postId

      await this.$store.dispatch('board/LOAD_POST', {boardId, postId})
      this.post = this.$store.state.board.postInfo

      // 유저정보
      let userInfo = this.$store.state.auth.userInfo
      if (!userInfo.email || !userInfo.is_activated) {
        const loginResult = await this.$store.dispatch('USER_INFO')
        if (typeof loginResult.error !== 'undefined' && loginResult.error !== null) {
          let msg = this.$constant.ALERT_MSG_UNDEFINED
          msg = `${msg  }\n${  loginResult.error}`
          alert(msg)
        } else {
          userInfo = this.$store.state.auth.userInfo
          this.activeUserInfo = userInfo
        }
      } else {
        this.activeUserInfo = userInfo
      }

      // 이전글 / 다음글
      await this.settingPrevNextPostId()
    },

    // 쿠키에 저장된 데이터를 불러온다.
    loadCookieBoard () {
      this.tableCurrentPage = VueCookie.get('table_current_page')
      this.tablePerPage = VueCookie.get('table_per_page')
      this.tableSearchKeyword = VueCookie.get('table_search_keyword')
    },

    //이전글/다음글 설정
    async settingPrevNextPostId () {
      const initPostData = { title:'', postId:0 }
      const boardId = this.boardId
      const page = parseInt(this.tableCurrentPage)
      const perPage = parseInt(this.tablePerPage)
      const keyword = this.tableSearchKeyword

      this.prevPost = initPostData
      this.nextPost = initPostData
      this.tablePrevPage = page
      this.tableNextPage = page

      // 현재 페이지의 공지사항을 불러온다.
      await this.$store.dispatch('board/LOAD_POST_LIST', {boardId, page, perPage, keyword})
      const postListInfo = this.$store.state.board.postListInfo
      const postList = postListInfo.data
      const postIndex = this.getListIndexPost(postList)
      const lastPage = parseInt(postListInfo.last_page)

      if (postIndex === -1) {
        // 현재 페이지가 없을 경우
        return
      }

      if (postIndex === 0) {
        // 현재페이지의 첫번째 게시글인 경우


        // 현재페이지가 첫번째 페이지인 경우 이전글 없음
        // 현재페이지가 첫번째 페이지가 아닌 경우 이전페이지의 마지막 게시글이 이전글
        if (page === 1) {
          this.prevPost = initPostData

        } else {
          await this.$store.dispatch('board/LOAD_POST_LIST', {boardId, page:(page - 1), perPage, keyword})
          const prevPostListInfo = this.$store.state.board.postListInfo
          this.prevPost = prevPostListInfo.data[prevPostListInfo.data.length - 1]
          this.tablePrevPage = page - 1
        }

        this.nextPost = postList[postIndex + 1]

      } else if (postIndex === (postList.length - 1)) {
        // 현재페이지의 마지막 게시글인 경우
        this.prevPost = postList[postIndex - 1]

        // 현재페이지가 마지막 페이지인 경우 이전글 없음
        // 현재페이지가 마지막 페이지가 아닌 경우 다음페이지의 첫번째 게시글이 다음글
        if (page === lastPage) {
          this.nextPost = initPostData
        } else {
          await this.$store.dispatch('board/LOAD_POST_LIST', {boardId, page:(page + 1), perPage, keyword})
          const nextPostListInfo = this.$store.state.board.postListInfo
          this.nextPost = nextPostListInfo.data[0]
          this.tableNextPage = page + 1
        }

      } else {

        // 현재페이지의 중간 게시글 인경우
        this.prevPost = postList[postIndex - 1]
        this.nextPost = postList[postIndex + 1]
      }
    },

    // 현재 페이지 인덱스 찾기
    getListIndexPost (postList) {
      let post = null
      for (let i = 0; i < postList.length; i++) {
        post = postList[i]
        if (parseInt(post.id) === parseInt(this.postId)) {
          return i
        }
      }
      return -1
    },

    // 글 삭제
    async deletePost (_postId) {
      const boardId = this.boardId
      const postId = _postId
      if (_postId <= 0) {
        return
      }
      await this.$store.dispatch('board/DELETE_POST', {boardId, postId})

      this.$router.back()
    },

    handleClickPrevPost (prevPost) {
      VueCookie.set('table_current_page', this.tablePrevPage)
      this.$router.push(`../${this.boardSlug}/${prevPost.id}`)
    },

    handleClickNextPost (nextPost) {
      VueCookie.set('table_current_page', this.tableNextPage)
      this.$router.push(`../${this.boardSlug}/${nextPost.id}`)
    },
    handleClickRegister (_title, _content) {
      this.registerPost(_title, _content)
    },
    handleClickCancel () {
      this.$router.back()
    },
    handleChangeFile (path, files) {
      this.fileUpLoad.files = files
    },
    handleSuccessFileUpload (uploadedFileID) {
      const file = this.fileUpLoad.files[this.fileUpLoad.files.length - 1]
      file.uploadedFileId = uploadedFileID
    },
    handleDeleteFile (file) {
      this.fileUpLoad.files.remove(file)
    }
  }
}
</script>

<style scoped>

</style>
